import api from './axios.js';

export const callsApi = {
  list: (params = {}) => api.get('/calls', { params }),
  get: (id) => api.get(`/calls/${id}`),
  recordingUrl: (id) => `/api/calls/${id}/recording`,
};
